module.exports = __webpack_public_path__ + "img/audio_thumbnail_nova.b737d92b.png";